module.exports = "<p>\n  help works!\n</p>\n"